const gridNumericScale = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const;

const gridTemplateScale = [...gridNumericScale, 'none', 'subgrid'] as const;

const spanBaseScale = [...gridNumericScale, 'full'] as const;

const spanScale = [...spanBaseScale, 'auto'] as const;

type GridNumericScale = (typeof gridNumericScale)[number];
type GridTemplateScale = (typeof gridTemplateScale)[number];
type SpanScale = (typeof spanScale)[number];
function generateGridVariants<T extends string | number>(
  scale: readonly T[],
  prefix: string,
) {
  return scale.reduce(
    (acc, value) => {
      acc[value] = `${prefix}-${value}`;
      return acc;
    },
    {} as Record<T, string>,
  );
}

const gridVariants = {
  gridCols: generateGridVariants(gridTemplateScale, 'grid-cols'),
  gridRows: generateGridVariants(gridTemplateScale, 'grid-rows'),
  // `auto` remaps to Tailwind's `col-auto`/`row-auto`; `col-span-auto` /
  // `row-span-auto` are not utilities and produced no CSS (VWA-169).
  colSpan: {
    ...generateGridVariants(spanBaseScale, 'col-span'),
    auto: 'col-auto',
  },
  rowSpan: {
    ...generateGridVariants(spanBaseScale, 'row-span'),
    auto: 'row-auto',
  },
  placeItems: {
    start: 'place-items-start',
    end: 'place-items-end',
    center: 'place-items-center',
    stretch: 'place-items-stretch',
    baseline: 'place-items-baseline',
  },
  placeContent: {
    start: 'place-content-start',
    end: 'place-content-end',
    center: 'place-content-center',
    stretch: 'place-content-stretch',
    between: 'place-content-between',
    around: 'place-content-around',
    evenly: 'place-content-evenly',
    baseline: 'place-content-baseline',
  },
  placeSelf: {
    // `baseline` is not a place-self value (Tailwind has no `place-self-baseline`)
    // and produced no CSS (VWA-169); use `alignSelf='baseline'` for baseline.
    auto: 'place-self-auto',
    start: 'place-self-start',
    end: 'place-self-end',
    center: 'place-self-center',
    stretch: 'place-self-stretch',
  },
} as const;

type GridVariants = typeof gridVariants;

export {
  type GridNumericScale,
  type GridTemplateScale,
  type GridVariants,
  gridVariants,
  type SpanScale,
};
